import { useAppointments } from '@/hooks/use-catalog';
import { PageHeader } from '@/components/layout/app-shell';
import { AppointmentCard } from '@/components/appointment-card';
import { Card, EmptyState, ErrorState, Skeleton, formatMoney, useTenant } from '@barber/ui';
import { appointmentTotalCents } from '@barber/shared';
import { BookOpen } from 'lucide-react';

/**
 * Histórico.
 *
 * O total gasto vem primeiro porque é a informação que o cliente não consegue
 * calcular sozinho — a lista abaixo ele já vive. Só entram atendimentos
 * CONCLUÍDOS: somar cancelados infla um número que ninguém pagou.
 */
export function HistoryPage() {
  const { locale } = useTenant();
  const historico = useAppointments('historico');

  const concluidos = historico.data?.filter((a) => a.status === 'COMPLETED') ?? [];
  const totalGasto = concluidos.reduce((soma, item) => soma + appointmentTotalCents(item), 0);

  return (
    <div className="flex flex-col gap-4">
      <PageHeader title="Histórico" description="Tudo que já passou." />

      {historico.isPending && (
        <div className="flex flex-col gap-3">
          <Skeleton className="h-20" />
          <Skeleton className="h-20" />
        </div>
      )}

      {historico.isError && (
        <ErrorState
          description="Não conseguimos carregar seu histórico."
          onRetry={() => void historico.refetch()}
        />
      )}

      {historico.isSuccess && historico.data.length === 0 && (
        <EmptyState
          icon={BookOpen}
          title="Seu histórico começa no primeiro corte"
          description="Depois do atendimento, ele aparece aqui."
        />
      )}

      {concluidos.length > 0 && (
        <Card className="flex items-center justify-between">
          <div>
            <p className="text-sm text-content-muted">Atendimentos concluídos</p>
            <p className="text-2xl font-bold text-content">{concluidos.length}</p>
          </div>

          <div className="text-right">
            <p className="text-sm text-content-muted">Total investido</p>
            <p className="text-2xl font-bold text-content">{formatMoney(totalGasto, locale)}</p>
          </div>
        </Card>
      )}

      {historico.data && historico.data.length > 0 && (
        <ul className="flex flex-col gap-3">
          {historico.data.map((appointment) => (
            <AppointmentCard key={appointment.id} appointment={appointment} />
          ))}
        </ul>
      )}
    </div>
  );
}
